export default __webpack_public_path__ + "static/media/result.3b4dd9b2.jpg";